import React from "react";
import { Modal, Form, Input, Select, DatePicker, Typography } from "antd";
import PropTypes from "prop-types";

const { Text } = Typography;
const { Option } = Select;

const TaskModal = ({
  visible,
  onOk,
  onCancel,
  confirmLoading,
  form,
  contentType,
  contentItems,
  loadingContent,
  disabledDate,
  onContentTypeChange,
}) => {
  return (
    <Modal
      title="Assign Task"
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}
      width={600}
      confirmLoading={confirmLoading}
      okText="Submit"
      centered
    >
      <Form form={form} layout="vertical" initialValues={{ contentType: undefined }}>
        <Form.Item name="memberId" label="Learner ID" hidden>
          <Input disabled type="hidden" />
        </Form.Item>

        <Form.Item name="memberName" label="Learner Name">
          <Input disabled />
        </Form.Item>

        <Form.Item
          name="title"
          label="Title"
          rules={[{ required: true, message: "Please enter task title" }]}
        >
          <Input placeholder="Enter task title" />
        </Form.Item>

        <Form.Item
          name="contentType"
          label="Select Task Type"
          rules={[{ required: true, message: "Please select a type" }]}
        >
          <Select placeholder="Select type" onChange={onContentTypeChange} loading={loadingContent}>
            <Option value={1}>Quiz</Option>
            <Option value={3}>Assignment</Option>
          </Select>
        </Form.Item>

        {contentType && (
          <Form.Item
            name="contentId"
            label={`Select ${contentType === 1 ? "Quiz" : "Assignment"}`}
            rules={[
              {
                required: true,
                message: `Please select a ${contentType === 1 ? "quiz" : "assignment"}`,
              },
            ]}
          >
            <Select
              placeholder={
                loadingContent
                  ? "Please wait..."
                  : `Select ${contentType === 1 ? "quiz" : "assignment"}`
              }
              loading={loadingContent}
              notFoundContent={
                !loadingContent &&
                contentItems.length === 0 && (
                  <Text>
                    No {contentType === 1 ? "quizzes" : "assignments"} available in the library
                  </Text>
                )
              }
            >
              {contentItems.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.title}
                </Option>
              ))}
            </Select>
          </Form.Item>
        )}

        <Form.Item
          name="deadline"
          label="Deadline"
          rules={[{ required: true, message: "Please select deadline" }]}
        >
          <DatePicker
            style={{ width: "100%" }}
            disabledDate={disabledDate}
            showTime={false}
            format="YYYY-MM-DD"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

TaskModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  confirmLoading: PropTypes.bool,
  form: PropTypes.object.isRequired,
  contentType: PropTypes.number,
  contentItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
    })
  ).isRequired,
  loadingContent: PropTypes.bool,
  disabledDate: PropTypes.func,
  onContentTypeChange: PropTypes.func.isRequired,
};

TaskModal.defaultProps = {
  confirmLoading: false,
  loadingContent: false,
  contentType: null,
  disabledDate: () => { },
};

export default TaskModal;
